import '../css/page.css';
import { Container, Row, Col } from 'react-bootstrap';

function Page2() {
  return (
    <div style={{ display: 'flex', height: 'auto', background: '#FFFFFF', paddingTop: '5rem', justifyContent: 'center', alignItems: 'center', maxWidth: '100vw' }}>
      <Container style={{ height: 'auto' }}>
        <Row style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} className='justify-content-center align-items-center'>
          <Col xs={12} md={6} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '2rem' }}>
            <div className='BlockWrapper' style={{ textWrap: 'balance', aspectRatio: '1 / 1', width: '90%' }}>
              <Container>
                <Row>
                  <h1 className='SubHeading' style={{wordBreak: 'break-word'}}>Smarter college & academic decisions, personalised for <b style={{ color: '#1E3A8A' }}>You</b>.</h1>
                </Row>
                <Row style={{ paddingTop: '2rem' }}>
                  <p style={{ maxWidth: '80vw', textAlign: 'center' }}>
                    AI-powered guidance helps you find the best universities, scholarships and opportunities, tailored to your unique strengths and goals.
                  </p>
                </Row>
              </Container>
            </div>
          </Col>
          <Col xs={12} md={6} className='justify-content-center align-items-center'>
            <img src={'https://media.istockphoto.com/id/1391240089/photo/happy-child-in-grey-shirt-learning-online-at-home-in-sunny-day.jpg?s=612x612&w=0&k=20&c=LgIFN-PuZ5kk-hdliaYt7CP0FJmDuDIONfLQ9biWKiM='} 
              style={{ borderRadius: '30px', aspectRatio: '1 / 1', objectFit: 'cover', display: 'block', margin: '0 auto', width: '90%', height: 'auto' }}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Page2;

// TODO: Image too big on mobile